import { type ReactNode } from 'react';
import type { CellTone } from './progressMatrix';
import styles from './trackBar.module.css';

const FILL: Record<CellTone, string> = {
  complete: styles.fillComplete as string,
  'at-risk': styles.fillAtRisk as string,
  blocked: styles.fillBlocked as string,
};

/**
 * A track with a tone-coloured fill to `percent`, used by the dependency mini-bars
 * (HeaderDependencies) so the tone→colour mapping lives in one place. (Floor
 * rollup cells no longer use this — MatrixCell renders its own two-tone fill by
 * percent bucket.) `className` sizes/shapes the track; `children` (label, coupled
 * icon) render over the fill.
 */
export function TrackBar({
  percent, tone, className, children,
}: {
  percent: number;
  tone: CellTone;
  className?: string;
  children?: ReactNode;
}) {
  return (
    <div className={`${styles.track} ${className ?? ''}`}>
      <div className={`${styles.fill} ${FILL[tone]}`} style={{ width: `${percent}%` }} />
      {children}
    </div>
  );
}
